var eRMaplocale = "pl"; // domyślnie pl

var eRMap = (function () {
    //PRIVATE
    var settings;
    var destinationExists = true;
    var openingMap = false;
    var path = null;
    var originPlace = null;

    // Ładowanie skryptu biblioteki Google Maps Api z odpowiednim Api Key dla JS
    loadScript = function () {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        if (settings.apiKeyJSRequired) {
            script.src = 'https://maps.googleapis.com/maps/api/js?v=3.39&key=' + settings.googleMapApiKeyJS + '&callback=showMap';
        } else {
            // jaki adres
            script.src = 'https://maps.googleapis.com/maps/api/js?v=3.39&callback=showMap';
        }
        document.body.appendChild(script);
    };

    showMap = function () {
        $('#' + settings.parentElementId)
            .gmap3({
                map: {
                    options: {
                        zoom: 15,
                        center: new google.maps.LatLng(0, 0),
                        maxZoom: 18,
                        mapTypeId: google.maps.MapTypeId.ROADMAP,
                        mapTypeControl: true,
                        navigationControl: true,
                        scrollwheel: true,
                        fullscreenControl: false,
                        mapTypeControlOptions: {
                            position: google.maps.ControlPosition.LEFT_BOTTOM
                        },
                        minZoom: 5,
                    }
                },
                callback: function (e) {
                    //  W przypadku, gdy załadowanie się mapy jest niemożliwe (np. błędny API Key), 
                    // biblioteka sama dba o to i pokazuje komunikat
                    return;
                }
            }, 'autofit');

        loadButtons();
        google.maps.event.addDomListener(map, 'tilesloaded', function () {
            google.maps.event.trigger(map, 'zoom_changed');
        });

        google.maps.event.addDomListener(map, 'idle', function () {
            CreatePrettyCheckbox();
            $('.mapControl').removeClass('visHidden');
            var trafficLayer = new google.maps.TrafficLayer();
            $("#traffic_checkbox").on("change", function () {
                showTraffic(trafficLayer);
            });
            setAddressInInput();
        });
    }

    showRoute = function () {
        openingMap = false;
        var origin = $('#address_input').val();
        $('#' + settings.parentElementId).gmap3({
            clear: {
                name: 'directionsrenderer'

            }
        });

        $('#' + settings.parentElementId)
            .gmap3({
                getroute: {
                    options: {
                        origin: origin,
                        destination: settings.destination,
                        travelMode: google.maps.DirectionsTravelMode.DRIVING
                        //BICYCLING
                        //WALKING
                    },
                    callback: function (results) {
                        if (!results) {
                            alertMsg({ message: eRMap.messages.determineWayError });
                            path = null;
                            originPlace = null;
                            return;
                        }
                        path = results.routes[0].overview_polyline;
                        originPlace = results.routes[0].legs[0].start_location.lat() + "," + results.routes[0].legs[0].start_location.lng();

                        $(this).gmap3({
                            map: {
                                options: {
                                    zoom: 15,
                                    maxZoom: 18,
                                    minZoom: 5,
                                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                                    mapTypeControl: true,
                                    navigationControl: true,
                                    scrollwheel: true,
                                    fullscreenControl: false,
                                    mapTypeControlOptions: {
                                        position: google.maps.ControlPosition.LEFT_BOTTOM
                                    }
                                }
                            },

                            directionsrenderer: {
                                options: {
                                    directions: results
                                }
                            }
                        })

                    }
                }
            }, "autofit");
    };

    showTraffic = function (trafficLayer) {
        if ($('#traffic_checkbox').is(':checked')) {
            trafficLayer.setMap(map);
        }
        else {
            trafficLayer.setMap(null);
        }
    };

    showMarkers = function () {
        $('#' + settings.parentElementId).gmap3({
            clear: {
                name: ['marker', 'directionsrenderer']
            },
            marker: {
                address: settings.destination,
                options: {
                    icon: "http://maps.google.com/mapfiles/marker_green.png"
                },
                events: {
                    click: function () {
                        var marker = $('#' + settings.parentElementId).gmap3({ get: { name: "marker" } });
                        var map = $(this).gmap3("get"), infowindow = $(this).gmap3({ get: { name: "infowindow" } });
                        if (infowindow) {
                            infowindow.open(map, marker);
                            infowindow.setContent(settings.destination);
                        } else {
                            $(this).gmap3({
                                infowindow: {
                                    anchor: marker,
                                    options: { content: settings.destination }
                                }
                            });
                        }
                    }
                },
                callback: function (results) {
                    if (!results) {
                        // Kiedy lokalizacja placówki nie istnieje
                        disableMapButtons();
                        destinationExists = false;
                        alertMsg({ message: eRMap.messages.showMarkersError });
                    }
                    else {
                        // Kiedy lokalizacja placówki istnieje
                        enableMapButtons();
                        destinationExists = true;
                    }
                }

            }
        }, 'autofit');

    };

    setAddressInInput = function () {
        if (openingMap) {
            if (settings.origin != "") {
                $('#address_input').val(settings.origin);
            }
            else {
                $('#address_input').val("");
            }
        }
    }

    disableMapButtons = function () {
        $('#control_map_route_button').addClass("mapControl-disabled");
        if (!settings.isMobileDevice) {
            $('#control_map_route_button').on("mouseleave", function () { $(this).css('backgroundColor', 'rgb(235, 235, 235)') });
        }
    }
    enableMapButtons = function () {
        $('#control_map_route_button').removeClass("mapControl-disabled");
        $('#control_map_route_button').on("mouseleave", function () { $(this).css('backgroundColor', 'white') });
    }
    createRouteButton = function (buttonDiv) {
        var controlUI = document.createElement('div');
        var controlText = document.createElement('div');
        var controlInput = document.createElement('input');

        $(buttonDiv).addClass('mapControlParent mapControlRoute');

        $(controlUI)
            .appendTo($(buttonDiv))
            .addClass('mapControl mapControlRoute-ui visHidden')
            .attr('id', 'control_map_route')
            .attr('title', eRMap.messages.setRoute)

        $(controlInput)
            .appendTo($(controlUI))
            .addClass('mapControlRoute-input')
            .attr('id', 'address_input')
            .attr('type', 'text')

        $(controlText)
            .appendTo($(controlUI))
            .addClass('mapControlRoute-text')
            .attr('id', 'control_map_route_button')
            .attr('type', 'text')
            .html(eRMap.messages.setRoute)

        if (!settings.isMobileDevice) {
            $(controlText).on('mouseover', function () { this.style.backgroundColor = "rgb(235, 235, 235)" });
            $(controlText).on('mouseleave', function () { this.style.backgroundColor = "white" });
        }

        if (settings.origin == "") {
            $(controlInput).attr('placeholder', eRMap.messages.initialAddress);
        }

        $(controlInput).on('keydown', function (e) {
            var code = e.keyCode || e.which
            if (code == 13) {
                e.preventDefault();
                $('#control_map_route_button').trigger('click');
                $(':focus').blur();
            }
        });

        google.maps.event.addDomListener(controlText, 'click', function () {
            showRoute();
        });
    };

    createCheckbox = function (buttonDiv) {
        var controlUI = document.createElement('div');
        var controlText = document.createElement('label');
        var controlCheck = document.createElement('input');

        $(buttonDiv).addClass('mapControlParent mapControlCheck');

        $(controlUI)
            .appendTo($(buttonDiv))
            .addClass('mapControl mapControlCheck-ui prettyCheckableCheckbox visHidden')
            .attr('id', 'control_map_check')
            .attr('title', eRMap.messages.traffic);

        $(controlText)
            .appendTo($(controlUI))
            .addClass('mapControlCheck-text')
            .attr('for', 'traffic_checkbox')
            .html(eRMap.messages.traffic);

        $(controlCheck)
            .appendTo($(controlUI))
            .addClass('mapControlCheck-check')
            .attr('id', 'traffic_checkbox')
            .attr('type', 'checkbox');
    };

    sourceToPrint = function (source) {
        var tmpStringBefore = "<html><head><title>" + eRMap.messages.printingMap + "</title><meta charset='utf-8'><script>function step1(){\n" +
            "setTimeout('step2()', 10);}\n" +
            "function step2(){window.print();window.close()}\n" +
            "</scri" + "pt></head><body onload='step1()'>\n" +
            "<img style='width:100%; height: auto;' src='";
        var tmpStringAfter = "' /></body></html>";
        return tmpStringBefore + source + tmpStringAfter;
    }

    createPrintButton = function (buttonDiv) {
        var controlText = document.createElement('div');

        $(buttonDiv).addClass('mapControlParent mapControlPrint');

        $(controlText)
            .appendTo($(buttonDiv))
            .addClass('mapControl mapControlPrint-text visHidden')
            .attr('id', 'control_map_print_button')
            .html(eRMap.messages.print)
            .attr('title', eRMap.messages.print);

        if (!settings.isMobileDevice) {
            $(controlText).on('mouseover', function () { this.style.backgroundColor = "rgb(235, 235, 235)" });
            $(controlText).on('mouseleave', function () { this.style.backgroundColor = "white" });
        }

        google.maps.event.addDomListener(controlText, 'click', function () {
            latLng = map.getCenter();
            var centarPlace = latLng.lat() + "," + latLng.lng();
            var showMarker = false;
            var place = centarPlace;
            $('#' + settings.parentElementId).gmap3({
                getlatlng: {
                    address: settings.destination,
                    callback: function (results) {
                        if (results) {
                            latLng = results[0].geometry.location;
                            showMarker = true;
                        }
                        place = latLng.lat() + "," + latLng.lng();
                    }
                }
            });
            map = $('#' + settings.parentElementId).gmap3('get');
            var zoom = map.getZoom();
            if (zoom > 15) {
                zoom = 15;
            }
            if (showMarker) {
                var linkFragment = "&markers=color:blue%7Clabel:%7C" + place;
                if (originPlace != null) {
                    linkFragment += "&markers=color:green%7Clabel:%7C" + originPlace;
                }
            }
            else {
                var linkFragment = "";
            }
            if (settings.apiKeyStaticRequired) {
                if (path == null) {
                    var source = decodeURIComponent("https://maps.googleapis.com/maps/api/staticmap?center=" + place + "&zoom=" + zoom + "&size=600x300&scale=2&maptype=roadmap" + linkFragment + "&key=" + settings.googleMapApiKeyStatic);
                } else {
                    zoom--;
                    var source = decodeURIComponent("https://maps.googleapis.com/maps/api/staticmap?center=" + centarPlace + "&zoom=" + zoom + "&size=600x300&scale=2" + linkFragment + "&path=enc:" + path + "&key=" + settings.googleMapApiKeyStatic);
                }
            }
            else {
                var source = decodeURIComponent("https://maps.googleapis.com/maps/api/staticmap?center=" + place + "&zoom=" + zoom + "&size=600x300&scale=2&maptype=roadmap&markers=color:blue%7Clabel:%7C" + place);
            }

            var printWindow = window.open();
            printWindow.document.write(sourceToPrint(source));

            if (destinationExists) {
                printWindow.document.write('<br /><br />' + settings.destination);
            }
            printWindow.document.close();

        });
    };

    loadButtons = function () {
        map = $('#' + settings.parentElementId).gmap3('get');
        var buttonRouteDiv = document.createElement('div');
        var checkDiv = document.createElement('div');
        var buttonPrintDiv = document.createElement('div');

        createRouteButton(buttonRouteDiv);
        createCheckbox(checkDiv);
        createPrintButton(buttonPrintDiv);

        //if (!settings.isMobileDevice) {
        //    map.controls[google.maps.ControlPosition.TOP_RIGHT].push(buttonRouteDiv);
        //    map.controls[google.maps.ControlPosition.TOP_RIGHT].push(checkDiv);
        //    map.controls[google.maps.ControlPosition.RIGHT_TOP].push(buttonPrintDiv);
        //}
        //else {
        //    map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(buttonRouteDiv);
        //    map.controls[google.maps.ControlPosition.TOP_RIGHT].push(checkDiv);
        //}

        map.controls[google.maps.ControlPosition.TOP_RIGHT].push(buttonRouteDiv);
        map.controls[google.maps.ControlPosition.RIGHT_TOP].push(checkDiv);
        map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(buttonPrintDiv);

    };

    // PUBLIC
    return {
        config: {
            googleMapApiKeyJS: "",
            googleMapApiKeyStatic: "",
            origin: "",
            parentElementId: "",
            language: eRMaplocale,
            isMobileDevice: true,
            apiKeyJSRequired: true,
            apiKeyStaticRequired: true
        },
        // "Konstruktor"
        init: function (options) {
            // pobiera domyślne ustawienia, a zmodyfikowane nadpisuje
            this.config = $.extend(this.config, options);
            settings = this.config;
            loadScript();
        },
        //  Odświeżenie mapy (konieczne wywołanie w widoku po init lub po maksymalizacji/minimalizacji okna)
        refresh: function () {
            map = $('#' + this.config.parentElementId).gmap3('get');
            center = map.getCenter();
            google.maps.event.trigger(map, 'resize');
            map.setCenter(center);
        },
        // Ustawienie adresów i pokazanie na mapie markera z adresem placówki z opcją wyznaczenia trasy
        // origin - miejsce zamieszkania pacjenta
        // destination - adres specjalności
        setAddresses: function (origin, destination) {
            path = null;
            originPlace = null;
            this.config.origin = origin;
            this.config.destination = destination;
            settings = this.config;
            openingMap = true;
            setAddressInInput();
            showMarkers();
        }
    };

})();
